export const isRootUrl = (url) => {
  if (!url) return false;
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.pathname === '/' || parsedUrl.pathname === '';
  } catch {
    const withoutProtocol = url.replace(/^[a-zA-Z]+:\/\//, '');
    const slashIndex = withoutProtocol.indexOf('/');
    return slashIndex === -1 || slashIndex === withoutProtocol.length - 1;
  }
};

export const normalizeUrl = (url) => {
  if (!url) return '';
  return url.trim().replace(/\/+$/, '');
};

export const sortPagesWithProjectUrlFirst = (pages, projectUrl) => {
  if (!Array.isArray(pages) || !projectUrl) return pages || [];
  
  const normalizedProjectUrl = normalizeUrl(projectUrl);
  
  return [...pages].sort((a, b) => {
    const aUrl = normalizeUrl(a.url);
    const bUrl = normalizeUrl(b.url);
    
    const aMatchesProject = aUrl === normalizedProjectUrl;
    const bMatchesProject = bUrl === normalizedProjectUrl;
    
    if (aMatchesProject && !bMatchesProject) return -1;
    if (!aMatchesProject && bMatchesProject) return 1;
    
    return 0;
  });
};


